export const SCHEMAS_BASE_URL = 'https://schemas.runware.ai'
export const CONTENT_BASE_URL = 'https://content.runware.ai'
